import { AxiosInstance } from "axios"

export type ContactFormData = {
  firstName: string
  lastName: string
  from: string
  company?: string
  phoneNumber?: string
  message: string
  formType: string
  howDidYouHearAboutUs: string
}

export class SendEmailApi {
  private client: AxiosInstance

  constructor(client: AxiosInstance) {
    this.client = client
  }

  execute = (data: ContactFormData) => this.client.post("mails/contact-form", data)
}
